import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { SidebarBox, ListItemStyle, LinkStyle, LogoutBox } from './style';
import { checkActiveTab, useWindowWide } from '../../utils/common_functions';
import { LogoutNewIcon } from '../../theme/SvgIcons';
import { menuItems } from '../../utils/constant';
import ConfirmationModal from '../Modal/ConfirmationModal';
import { toast } from 'react-toastify';
import { updateActivityDrawer } from '../../redux/sidebar/SidebarSlice';
import { logout } from '../../redux/globalAction';
import useFilteredMenuItems from '../../hooks/useFilteredMenuItems';
import { Tooltip } from 'antd';
import { useTheme } from '@emotion/react';
import { logoutUrl } from '../../redux/sign-in/apiRoute';

const SideBar = () => {
  const [selectedMenu, setSelectedMenu] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const loc = useLocation();
  const largeScreen = useWindowWide(750);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();

  const { user_details, permissions, isEmployee, isSidebarOpen, userInfo } = useSelector(
    (state) => ({
      user_details: state?.userInfo?.data?.user_details,
      permissions: state?.userInfo?.data?.permissions,
      isEmployee: state?.userInfo?.isEmployee,
      isSidebarOpen: state?.sidebar?.isSidebarOpen,
      userInfo: state?.userInfo
    })
  );

  const filteredMenuItems = useFilteredMenuItems(permissions, isEmployee, menuItems);

  const handleLogout = async () => {
    setDeleteLoading(true);
    try {
      let res = await logoutUrl({
        deviceId: userInfo?.deviceId
      });

      if (res?.statusCode === 200) {
        dispatch(logout());
        toast.success('Logout Successfully');
        navigate('/');
      } else {
        toast.error(res?.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    const activeTab = checkActiveTab(loc.pathname);
    setSelectedMenu(activeTab);
    dispatch(updateActivityDrawer(false));
  }, [loc, dispatch]);

  return (
    largeScreen && (
      <SidebarBox isSidebarOpen={isSidebarOpen}>
        {openLogoutModal && (
          <ConfirmationModal
            open={openLogoutModal}
            onCancel={() => setOpenLogoutModal(false)}
            title="Logout"
            onSubmit={handleLogout}
            buttonName="Yes"
            description="Are you sure you want to logout this account?"
            iconBG="#FB4A49"
            loading={deleteLoading}
          />
        )}
        <div style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {filteredMenuItems.map((_item, key) => (
            <LinkStyle key={key} to={_item.path} state={{ id: user_details?.id }}>
              <ListItemStyle
                key={_item.id}
                disablePadding
                isSidebarOpen={isSidebarOpen}
                className={selectedMenu === _item.name ? 'active' : ''}>
                {isSidebarOpen ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px 16px',
                      cursor: 'pointer',
                      width: '100%'
                    }}>
                    {_item.icon}
                    <span style={{ marginLeft: '12px' }}>{_item.name}</span>
                  </div>
                ) : (
                  <Tooltip title={_item.name} placement="right" color={theme.primaryColor}>
                    <div
                      className="close-sidebar-btn"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '8px',
                        cursor: 'pointer',
                        width: '100%'
                      }}>
                      {_item.icon}
                    </div>
                  </Tooltip>
                )}
              </ListItemStyle>
            </LinkStyle>
          ))}
        </div>
        <LogoutBox
          className={!isSidebarOpen ? 'close-sidebar-btn' : ''}
          onClick={() => setOpenLogoutModal(true)}>
          <LogoutNewIcon />
          {isSidebarOpen && <h4>Logout</h4>}
        </LogoutBox>
      </SidebarBox>
    )
  );
};

export default memo(SideBar);
